import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SettingsService, AccountSettingsType } from '../../core';
import { ITemplateListSettings } from '../models/template-list-settings';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class TemplateListSettingsResolver implements Resolve<any> {
	constructor(private _settingsService: SettingsService) { }

	resolve(): Observable<ITemplateListSettings> {
		return this._settingsService.getSettings<ITemplateListSettings>(AccountSettingsType.TemplateListSettings, true)
			.pipe(map(s => {
				if (s) {
					return s;
				}
				return of(null);
			})).pipe(catchError(e => {
				return of(null);
			}));
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/resolvers/template-list-settings.resolver.ts